import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';


@Injectable()
export class CargaDeGasolinaService {

  constructor(private afDB:AngularFireDatabase, private afs:AngularFirestore) { }

    /**
     *  Obtiene la información de una sola carga de gasolina
     * @param idCarga 
     */
    public obtenerCargaDeGasolina(idCarga:string){  
        return this.afs.collection('cargasDeGasolina').doc(idCarga);
    }

    /**
     * Actualiza la información particular de una carga de gasolina
     * @param idCarga 
     * @param actualizacion 
     */
    public editarCargaDeGasolina(idCarga:string, actualizacion:any){
        return this.afs.collection('cargasDeGasolina').doc(idCarga).update(actualizacion);
    }

    public obtenerCGEntreFechas(fechaInicial, fechaFinal){
        return this.afs.collection('cargasDeGasolina', ref => ref.where('fecha', '>=', fechaInicial).where('fecha', '<=', fechaFinal).orderBy('fecha','asc'));
    }

    public generarNuevaCarga(objetoCarga){
       return  this.afs.collection('cargasDeGasolina').add(objetoCarga)
    }

    /**
     * Obtiene los precios de todas las gasolinas
     */
    public obtenerPreciosDeGasolina(){
        return this.afs.collection('preciosDeGasolina');
    }

    /**
     * Actualiza el precio de una gasolina
     * @param gasolina 
     * @param precio 
     */
    public actualizarPrecioGasolina(gasolina, precio){
        return this.afs.collection('preciosDeGasolina').doc(gasolina).update({ precio });
    }
    /**
     * Eliminar registro de carga
     * @param idRegustro 
     */
    public eliminarCDGporID(idCarga){
        return  this.afs.collection('cargasDeGasolina').doc(idCarga).delete();
    }

    public obtenerPenultimaCargaPorUnidad(fecha, unidad){
        return this.afs.collection('cargasDeGasolina',ref=>ref.where('fecha','<',fecha).where('unidad','==',unidad).orderBy('fecha','asc'))
    }

    public cargasPorOperador(operador){
        return this.afs.collection('cargasDeGasolina',ref=>ref.where('operador','==',operador))
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/carga-de-gasolina.service.ts